import React from 'react';
const ThermometerAsset = ({
  color
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "186",
    height: "609",
    viewBox: "0 0 186 609"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(-1332 -290)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union_4",
    "data-name": "Union 4",
    transform: "translate(1332 290)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,516a92.953,92.953,0,0,1,46-80.267V47.5a47.5,47.5,0,0,1,95,0V436.328A93.006,93.006,0,1,1,0,516Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 92.99964904785156 589.0003662109375 C 133.2523498535156 589.0003662109375 166.0003509521484 556.25244140625 166.0003509521484 515.999755859375 C 166.0003509521484 490.192138671875 152.7902526855469 466.8090515136719 130.6632537841797 453.449951171875 L 121.0003509521484 447.615966796875 L 121.0003509521484 436.3284606933594 L 121.0003509521484 47.50025177001953 C 121.0003509521484 32.33655166625977 108.6637496948242 20.00005340576172 93.50005340576172 20.00005340576172 C 78.33634948730469 20.00005340576172 65.99985504150391 32.33655166625977 65.99985504150391 47.50025177001953 L 65.99985504150391 435.7330627441406 L 65.99985504150391 447.1865539550781 L 56.12135314941406 452.9828491210938 C 33.8409538269043 466.05615234375 20.00005340576172 490.2028503417969 20.00005340576172 515.999755859375 C 20.00005340576172 556.25244140625 52.74755096435547 589.0003662109375 92.99964904785156 589.0003662109375 M 92.99964904785156 609.0003662109375 C 41.63755416870117 609.0003662109375 5.258788951323368e-05 567.3627319335938 5.258788951323368e-05 515.999755859375 C 5.258788951323368e-05 481.7823486328125 18.4764518737793 451.8827514648438 45.99985122680664 435.7330627441406 L 45.99985122680664 47.50025177001953 C 45.99985122680664 21.26615333557129 67.26685333251953 5.258788951323368e-05 93.50005340576172 5.258788951323368e-05 C 119.7332534790039 5.258788951323368e-05 141.0003509521484 21.26615333557129 141.0003509521484 47.50025177001953 L 141.0003509521484 436.3284606933594 C 167.9695587158203 452.6110534667969 186.0003509521484 482.1992492675781 186.0003509521484 515.999755859375 C 186.0003509521484 567.3627319335938 144.3627471923828 609.0003662109375 92.99964904785156 609.0003662109375 Z",
    stroke: "none",
    fill: color
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x2: "36",
    transform: "translate(1393.5 677.5)",
    fill: "none",
    stroke: color,
    strokeWidth: "10"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x2: "36",
    transform: "translate(1393.5 539.5)",
    fill: "none",
    stroke: color,
    strokeWidth: "10"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    x2: "36",
    transform: "translate(1393.5 401.5)",
    fill: "none",
    stroke: color,
    strokeWidth: "10"
  }))));
};
export default ThermometerAsset;